<script setup>
import AppLayout from "@/Layouts/AppLayout.vue";
import {usePage} from "@inertiajs/vue3";
import {getArrSortsReview} from "@/constants.js";
import {ref} from "vue";
import Review from "@/Pages/User/Components/Review.vue";
import UserCard from "@/Pages/User/Components/UserCard.vue";

const page = usePage(),
    user = page.props.user,
    selectFilter = ref(getArrSortsReview()[0]),
    reviewsCount = ref(page.props.reviews.total),
    pageTitle = user.name

const setSelectedFilter = (selectedFilter) => {
    selectFilter.value = selectedFilter
}

</script>

<template>
    <AppLayout :title="pageTitle">
        <div class="flex flex-col max-w-[48.75rem] m-auto gap-2.5">
            <UserCard @set-selected-filter="setSelectedFilter" :selected-filter="selectFilter" />
            <Review :filter="selectFilter" @update-count-review="reviewsCount = page.props.reviews.total"/>
        </div>
    </AppLayout>
</template>

<style scoped>

</style>
